module.exports = __webpack_public_path__ + "static/media/newsImage10.d98284a0.svg";